

export default {
  props: {
    label: {
      type: String,
      default: () => "Notification tab",
      required: true,
    },
    content: {
      type: Array,
      default: () => [],
      required: true,
    },
    link: {
      type: String,
      default: () => null,
    },
  },
  computed: {
    labelLowerCase() {
      return this.label ? this.label.toLowerCase() : ""
    },
    contentLink() {
      let link
      switch (this.content.type) {
        case 'program':
          link = "/programmas"
        break;
        case 'person':
          link = "/redacteuren-en-gastauteurs"
        break;
        default: null
      }

      return link
    },
  },
  methods: {
    onClickArticle (article) {
      // Send event to GTM
      if (this.$gtm) {
        this.$gtm.push({
          event: 'eo_notification',
          'method': 'click',
          'content_type': 'article',
          'item_id': article.id,
        })
      }
    },
  },
}
